const INITAL_STATE = {
    titulo: '',
    descricao: ''
}

export default (state = INITAL_STATE, action) => {
    switch (action.type) {
        case 'SET_SERVICO_NAO_HABILITADO_MEU_INSS':
            return {...state, titulo: action.payload.titulo, descricao: action.payload.descricao}
        case 'LIMPAR_SERVICO_NAO_HABILITADO_MEU_INSS':
            return {...INITAL_STATE}
        default:
            return state;
    }
}